import React, { FC, useEffect, useState } from 'react';
import { Button } from '@mui/material';

import { IAvailabilityDTO } from 'src/api/dtos';
import { CalendarDateIcon } from 'src/shared/components';
import { FeaturesEnums } from 'src/shared/enums';
import { ComponentWithFeatures } from 'src/shared/hocs';
import { useTranslate } from 'src/shared/providers';

import { EmployeeAvailabilityDrawer } from './EmployeeAvailabilityDrawer';
import { EmployeeAvailabilityAddCycleProvider } from './providers/EmployeeAvailabilityAddCycleProvider';

interface Props {
  defaultAvailability: IAvailabilityDTO | undefined;
  onResetAvailability: () => void;
}

export const EmployeeAvailabilityButton: FC<Props> = ({ defaultAvailability, onResetAvailability }) => {
  const { t } = useTranslate();
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    if (defaultAvailability) {
      setOpen(true);
    }
  }, [defaultAvailability]);

  const handleClose = () => {
    setOpen(false);
    onResetAvailability();
  };

  return (
    <>
      <ComponentWithFeatures features={FeaturesEnums.SchedulingAvailability}>
        <Button startIcon={<CalendarDateIcon />} color="secondary" onClick={() => setOpen(true)}>
          {t('global.availability')}
        </Button>
        <EmployeeAvailabilityAddCycleProvider>
          <EmployeeAvailabilityDrawer defaultDate={defaultAvailability?.date} open={open} onClose={handleClose} />
        </EmployeeAvailabilityAddCycleProvider>
      </ComponentWithFeatures>
    </>
  );
};
